import React from 'react';
import { Phone, CheckCircle, Wrench, Truck, Settings, Droplet, Gauge } from 'lucide-react';
export function IsuzuRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6218">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6219">
        <div className="container mx-auto px-4" data-id="element-6220">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6221">
            Isuzu Truck Repair and Maintenance
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6222">
            Complete Isuzu Truck System Maintenance and Repair Services
          </p>
          <p className="text-lg text-gray-200 text-center mt-2" data-id="element-6223">
            Including maintenance, inspection, diagnostics, and repair
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6224">
        <div className="max-w-4xl mx-auto" data-id="element-6225">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6226">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6227">
              Garrett Auto and Truck Service: Isuzu Commercial Truck Specialists
            </h2>

            <p className="text-lg text-gray-700 mb-4" data-id="element-6228">
              <strong data-id="element-6229">
                Experience the Best in Isuzu Truck Maintenance and Repair
              </strong>
            </p>

            <p className="text-gray-700" data-id="element-6230">
              Welcome to Garrett Auto and Truck Service, where we offer expert
              care for your Isuzu commercial trucks. Our team specializes in
              providing top-notch service for each Isuzu model, ensuring they
              run efficiently and reliably.
            </p>
          </div>

          {/* Isuzu N-Series */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6231">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6232">
              Isuzu N-Series: Versatility Meets Reliability
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6233">
              Benefits of the N-Series
            </h3>
            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-6234">
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-6235">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6236">Compact Design</h4>
                <p className="text-gray-700 text-sm" data-id="element-6237">
                  Ideal for city and urban environments
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-6238">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6239">
                  Fuel Efficiency
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6240">
                  Excellent for optimizing operation costs
                </p>
              </div>
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-6241">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6242">
                  Maneuverability
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6243">
                  Easy to navigate in tight spaces
                </p>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6244">
              Maintenance and Repair for the N-Series
            </h3>
            <div className="space-y-3" data-id="element-6245">
              <div className="flex items-start" data-id="element-6246">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6247" />
                <div data-id="element-6248">
                  <strong className="text-gray-900" data-id="element-6249">Engine Care:</strong>
                  <span className="text-gray-700" data-id="element-6250">
                    {' '}
                    Regular oil changes and fuel system checks for both gasoline
                    and diesel models
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6251">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6252" />
                <div data-id="element-6253">
                  <strong className="text-gray-900" data-id="element-6254">Brake Service:</strong>
                  <span className="text-gray-700" data-id="element-6255">
                    {' '}
                    Frequent inspections and maintenance due to urban usage
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6256">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6257" />
                <div data-id="element-6258">
                  <strong className="text-gray-900" data-id="element-6259">Electrical System:</strong>
                  <span className="text-gray-700" data-id="element-6260">
                    {' '}
                    Regular check-ups for intricate electrical systems
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Isuzu F-Series */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6261">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6262">
              Isuzu F-Series: Power and Performance for Heavier Loads
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6263">
              Benefits of the F-Series
            </h3>
            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-6264">
              <div className="bg-green-50 rounded-lg p-4" data-id="element-6265">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6266">
                  Powerful Engines
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6267">
                  Designed for heavy-duty tasks
                </p>
              </div>
              <div className="bg-green-50 rounded-lg p-4" data-id="element-6268">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6269">
                  Spacious Cabins
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6270">
                  Comfortable for long hauls
                </p>
              </div>
              <div className="bg-green-50 rounded-lg p-4" data-id="element-6271">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6272">Durability</h4>
                <p className="text-gray-700 text-sm" data-id="element-6273">
                  Built to withstand rigorous use
                </p>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6274">
              Maintenance and Repair for the F-Series
            </h3>
            <div className="space-y-3" data-id="element-6275">
              <div className="flex items-start" data-id="element-6276">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6277" />
                <div data-id="element-6278">
                  <strong className="text-gray-900" data-id="element-6279">
                    Diesel Engine Maintenance:
                  </strong>
                  <span className="text-gray-700" data-id="element-6280">
                    {' '}
                    Special focus on turbochargers and cooling systems
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6281">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6282" />
                <div data-id="element-6283">
                  <strong className="text-gray-900" data-id="element-6284">Transmission Care:</strong>
                  <span className="text-gray-700" data-id="element-6285">
                    {' '}
                    Regular checks and servicing for both manual and automatic
                    models
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6286">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6287" />
                <div data-id="element-6288">
                  <strong className="text-gray-900" data-id="element-6289">
                    Suspension and Steering:
                  </strong>
                  <span className="text-gray-700" data-id="element-6290">
                    {' '}
                    More frequent inspections recommended due to heavier loads
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Isuzu NPR */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6291">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6292">
              Isuzu NPR: The All-Rounder for Diverse Needs
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6293">
              Benefits of the NPR
            </h3>
            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-6294">
              <div className="bg-purple-50 rounded-lg p-4" data-id="element-6295">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6296">Flexibility</h4>
                <p className="text-gray-700 text-sm" data-id="element-6297">
                  Suits a wide range of industries
                </p>
              </div>
              <div className="bg-purple-50 rounded-lg p-4" data-id="element-6298">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6299">
                  Economical Operation
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6300">
                  Good fuel economy and low maintenance costs
                </p>
              </div>
              <div className="bg-purple-50 rounded-lg p-4" data-id="element-6301">
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-6302">Driver Comfort</h4>
                <p className="text-gray-700 text-sm" data-id="element-6303">
                  Ergonomically designed for ease of use
                </p>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6304">
              Maintenance and Repair for the NPR
            </h3>
            <div className="space-y-3" data-id="element-6305">
              <div className="flex items-start" data-id="element-6306">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6307" />
                <div data-id="element-6308">
                  <strong className="text-gray-900" data-id="element-6309">
                    Routine Maintenance:
                  </strong>
                  <span className="text-gray-700" data-id="element-6310">
                    {' '}
                    Importance of adhering to service schedules for long-term
                    reliability
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6311">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6312" />
                <div data-id="element-6313">
                  <strong className="text-gray-900" data-id="element-6314">
                    Brake and Tire Service:
                  </strong>
                  <span className="text-gray-700" data-id="element-6315">
                    {' '}
                    Essential for safety and efficiency
                  </span>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6316">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6317" />
                <div data-id="element-6318">
                  <strong className="text-gray-900" data-id="element-6319">Cooling System:</strong>
                  <span className="text-gray-700" data-id="element-6320">
                    {' '}
                    Regular checks to prevent overheating, especially under
                    heavy use
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Our Services */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6321">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6322">
              Garrett Auto and Truck Service: Your Isuzu Maintenance Experts
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-6323">
              At Garrett Auto and Truck Service, we understand the unique needs
              of each Isuzu model. Our team is equipped with the knowledge and
              tools to provide the best maintenance and repair services,
              ensuring your Isuzu truck remains a reliable asset for your
              business.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-6324">
              <div className="text-center" data-id="element-6325">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6326">
                  <Settings className="text-blue-600" size={32} data-id="element-6327" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-6328">
                  Tailored Services
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-6329">
                  Custom maintenance plans for each Isuzu model
                </p>
              </div>

              <div className="text-center" data-id="element-6330">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6331">
                  <Wrench className="text-green-600" size={32} data-id="element-6332" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-6333">
                  Quality Parts
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-6334">
                  Genuine Isuzu parts and state-of-the-art diagnostic tools
                </p>
              </div>

              <div className="text-center" data-id="element-6335">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6336">
                  <CheckCircle className="text-purple-600" size={32} data-id="element-6337" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-6338">
                  Professional Team
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-6339">
                  Trained in latest Isuzu truck care techniques
                </p>
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-6340">
              Comprehensive Maintenance Services
            </h3>
            <div className="grid md:grid-cols-2 gap-3" data-id="element-6341">
              <div className="flex items-start" data-id="element-6342">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6343" />
                <span className="text-gray-700" data-id="element-6344">
                  Engine oil and filter changes
                </span>
              </div>
              <div className="flex items-start" data-id="element-6345">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6346" />
                <span className="text-gray-700" data-id="element-6347">
                  Fluid top-offs and monitoring
                </span>
              </div>
              <div className="flex items-start" data-id="element-6348">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6349" />
                <span className="text-gray-700" data-id="element-6350">
                  Brake inspections and service
                </span>
              </div>
              <div className="flex items-start" data-id="element-6351">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6352" />
                <span className="text-gray-700" data-id="element-6353">
                  Advanced diagnostic services
                </span>
              </div>
              <div className="flex items-start" data-id="element-6354">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6355" />
                <span className="text-gray-700" data-id="element-6356">
                  Tire maintenance and rotation
                </span>
              </div>
              <div className="flex items-start" data-id="element-6357">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6358" />
                <span className="text-gray-700" data-id="element-6359">
                  Cooling system maintenance
                </span>
              </div>
            </div>
          </div>

          {/* Industries Served */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6360">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6361">
              Industries We Serve
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-6362">
              Isuzu commercial trucks serve various industries, and each
              industry has specific needs that Isuzu trucks cater to:
            </p>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-6363">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6364">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6365">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6366" />
                  Landscaping
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6367">
                  Retaining walls, deck construction, tree service, lawn care
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6368">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6369">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6370" />
                  Delivery Services
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6371">
                  Furniture, groceries, appliances, general freight, food
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6372">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6373">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6374" />
                  HVAC & Plumbing
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6375">
                  Heating, cooling, plumbing services with extra storage
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6376">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6377">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6378" />
                  Vending Services
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6379">
                  Powerful hauling for vending machine businesses
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6380">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6381">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6382" />
                  Junk Removal
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6383">
                  Residential and commercial with dump features
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6384">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6385">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6386" />
                  Moving Companies
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6387">
                  Excellent fuel economy and customizable cabs
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6388">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6389">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6390" />
                  Electricians
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6391">
                  Reliable performance with ample cargo space
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6392">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6393">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6394" />
                  Construction
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6395">
                  Durability and hauling for construction needs
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6396">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6397">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6398" />
                  Agriculture
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6399">
                  Powerful engine with customizable bed options
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-6400">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-6401">
                  <Truck className="mr-2 text-[#B1050B]" size={20} data-id="element-6402" />
                  Rental Companies
                </h4>
                <p className="text-gray-700 text-sm" data-id="element-6403">
                  Maintenance-free ignition and long-life timing chain
                </p>
              </div>
            </div>
          </div>

          {/* Common Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6404">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-6405">
              Common Repairs and Maintenance
            </h2>

            <div className="space-y-6" data-id="element-6406">
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-6407">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6408">
                  <Wrench className="mr-2 text-[#B1050B]" size={24} data-id="element-6409" />
                  Engine Maintenance
                </h3>
                <p className="text-gray-700" data-id="element-6410">
                  Regular cleaning of the engine is crucial, especially in
                  diesel engines, to prevent performance reduction and extend
                  road life.
                </p>
              </div>

              <div className="border-l-4 border-blue-500 pl-6" data-id="element-6411">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6412">
                  <Droplet className="mr-2 text-blue-600" size={24} data-id="element-6413" />
                  Oil and Filter Changes
                </h3>
                <p className="text-gray-700" data-id="element-6414">
                  Regular oil and filter changes are essential to prevent engine
                  oil contamination from dirt, dust, and debris, ensuring
                  optimal engine performance.
                </p>
              </div>

              <div className="border-l-4 border-green-500 pl-6" data-id="element-6415">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6416">
                  <Settings className="mr-2 text-green-600" size={24} data-id="element-6417" />
                  Fluid Monitoring
                </h3>
                <p className="text-gray-700" data-id="element-6418">
                  Keeping an eye on and regularly replacing/changing engine
                  coolant, brake fluid, power steering fluids, and windshield
                  washer fluid is vital for performance and safety.
                </p>
              </div>

              <div className="border-l-4 border-purple-500 pl-6" data-id="element-6419">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-6420">
                  <Gauge className="mr-2 text-purple-600" size={24} data-id="element-6421" />
                  Tire Maintenance
                </h3>
                <p className="text-gray-700" data-id="element-6422">
                  Regular inspection of tire pressure and tread depth is
                  important for safe driving and fuel efficiency. Tires should
                  be changed when tread depth becomes insufficient, and rotated
                  regularly for even wear.
                </p>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mt-6" data-id="element-6423">
              <p className="text-gray-800" data-id="element-6424">
                <strong data-id="element-6425">Important:</strong> These maintenance and repair
                practices are crucial for ensuring the longevity and efficiency
                of Isuzu commercial trucks across various industries.
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6426">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6427">
              Schedule Your Isuzu Service Today
            </h2>
            <p className="text-xl mb-6" data-id="element-6428">
              Expert Repair and Maintenance for Your Isuzu Commercial Trucks
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6429">
              <Phone className="mr-3" size={24} data-id="element-6430" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6431">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
            <p className="mt-2 text-gray-400" data-id="element-6432">
              Trust Garrett Auto and Truck Service - Your Partner in Keeping
              Isuzu Trucks on the Road
            </p>
          </div>
        </div>
      </div>
    </div>;
}